import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	DOCUMENT_CATEGORY_FEATURE_KEY,
	DocumentCategoryState,
	DocumentCategoryPartialState,
	documentCategoryAdapter
} from './document-category.reducer';

// Lookup the 'DocumentCategory' feature state managed by NgRx
export const getDocumentCategoryState = createFeatureSelector<
	DocumentCategoryPartialState,
	DocumentCategoryState
>(DOCUMENT_CATEGORY_FEATURE_KEY);

const { selectAll, selectEntities } = documentCategoryAdapter.getSelectors();

export const getDocumentCategoryLoaded = createSelector(
	getDocumentCategoryState,
	(state: DocumentCategoryState) => state.loaded
);

export const getDocumentCategoryError = createSelector(
	getDocumentCategoryState,
	(state: DocumentCategoryState) => state.error
);

export const loadingDocumentCategory = createSelector(
	getDocumentCategoryState,
	(state: DocumentCategoryState) => state.loaded
);

export const getAllDocumentCategory = createSelector(
	getDocumentCategoryState,
	(state: DocumentCategoryState) => selectAll(state)
);

export const getDocumentCategoryEntities = createSelector(
	getDocumentCategoryState,
	(state: DocumentCategoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getDocumentCategoryState,
	(state: DocumentCategoryState) => state.selectedDocumentCategoryId
);

export const getSelected = createSelector(
	getDocumentCategoryEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
